import { render, staticRenderFns } from "./tripteev-plan-card.vue?vue&type=template&id=5f1c11e6"
import script from "./tripteev-plan-card.vue?vue&type=script&lang=js"
export * from "./tripteev-plan-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports